<div style="display: block;">
    <canvas baseChart
       [data]="data"
       [options]="options"
       [ngStyle]="{'height': chartHeight}"
       class="line-chart"
       id="line-chart"
       [type]="'line'"
       [attr.aria-label]="ariaLabel"
       >
    </canvas>
  </div>
